import { personalizedSlipSchema } from "@redotech/redo-model/personalized-slip/personalized-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getPersonalizedSlipTemplate = {
  name: "getPersonalizedSlipTemplate" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: personalizedSlipSchema,
};
